import equals from 'ramda/es/equals';
import union from 'ramda/es/union';
import isEmpty from './isEmpty';
import isObject from './isObject';

const isValidEmpty = x =>
  Array.isArray(x) || x === false || isObject(x) || x === '';

const deepMerge = (first, second) => {
  if (isEmpty(first)) {
    if (isValidEmpty(first) && isEmpty(second)) {
      return first;
    }
    return second;
  }
  if (isEmpty(second)) {
    if (isValidEmpty(second) && isEmpty(first)) {
      return second;
    }
    return first;
  }
  if (equals(first, second)) return second;
  if (
    first.length &&
    second.length &&
    typeof first !== 'string' &&
    typeof second !== 'string'
  ) {
    // return union(first, second);
    // if first is larger, map through first, but prioritize second value
    if (first.length > second.length) {
      return first.map((firstItem, index) =>
        deepMerge(firstItem, second[index])
      ); // latter is higher priority
    } else {
      return second.map((secondItem, index) =>
        deepMerge(first[index], secondItem)
      );
    }
  }

  if (!(isObject(first) && isObject(second))) return second;

  const firstKeys = Object.keys(first);
  const secondKeys = Object.keys(second);
  const keys = union(firstKeys, secondKeys);

  return keys.reduce(
    (result, key) => ({
      ...result,
      [key]: deepMerge(first[key], second[key])
    }),
    {}
  );
};

export default deepMerge;
